
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"d":"M29 8H11c-1.688 0-3 1.36-3 3v13.5c0 1.688 1.313 3 3 3h4.5v3.938c0 .375.234.562.563.562.093 0 .187 0 .328-.094L22.25 27.5H29c1.64 0 3-1.313 3-3V11c0-1.64-1.36-3-3-3zm1.5 16.5c0 .844-.703 1.5-1.5 1.5h-7.266l-.422.328L17 29.563V26h-6a1.48 1.48 0 01-1.5-1.5V11c0-.797.656-1.5 1.5-1.5h18c.797 0 1.5.703 1.5 1.5v13.5zm-9.375-5.25h-6.75a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h6.75a.37.37 0 00.375-.375v-.75a.403.403 0 00-.375-.375zm4.5-4.5h-11.25a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h11.25a.37.37 0 00.375-.375v-.75a.403.403 0 00-.375-.375z","fill":"#586E8C"}})])
          )
        }
      }
    